
/* addon: Change Unit-Price for Variant whenever it is changed */

document.addEventListener('variant:change', function(event) {
    
    // function is initiated when user changes variant on product page

    // get variant and productId 
    var variant = event.detail.variant;
    var json_script_el = document.getElementsByClassName('variant-unit-prices-' + variant.id)[0];
    var product_id = json_script_el.dataset.productId;
    
    // get unit price for retrieved variant
    var variant_units = JSON.parse(json_script_el.textContent)
    var unit_price = variant_units[variant.id];

    console.log(variant);
    console.log(variant_units);
    console.log(unit_price);

    // Generate HTML with new unit-price of variant
    

    // Get all unit-price elements (multiples on same page) and update HTML
    var unit_price_elements = document.getElementsByClassName('customized-unit-price-' + product_id);
    
    for(var i = 0; i < unit_price_elements.length; i++) {
        const node = document.createRange().createContextualFragment(unit_price);
        unit_price_elements[i].lastChild.replaceWith(node);
        // unit_price_elements[1].innerHTML = unit_price;
    }

  });